export default "__VITE_ASSET__40a4a35a__"